// extracted by mini-css-extract-plugin
export var bodySections = "_cx-8";
export var gray = "_cx-7";
export var green = "_cx-4";
export var iconContainer = "_cx-9";
export var iconWidgetContainer = "_cx-1";
export var phoneIcon = "_cx-2";
export var red = "_cx-5";
export var statusDot = "_cx-3";
export var widgetContainer = "_cx-0";
export var yellow = "_cx-6";